// web/src/console/sections/DeploymentsSection.tsx
import type { JSX } from "react";
import { useState } from "react";
import { adminApi } from "../../lib/adminApi";
import { useAsync } from "../useAsync";
import { fmtRelative, fmtAbsTime } from "../format";

export function DeploymentsSection(): JSX.Element {
  const { data, loading, error, reload } = useAsync(() => adminApi.deployments(), []);
  const [open, setOpen] = useState<string | null>(null);
  if (loading) return <div className="cc-skeleton" style={{ height: 200 }} />;
  if (error || !data) return <div className="cc-empty">Failed to load deployments. <button className="cc-back" onClick={reload}>Retry</button></div>;
  const rows = data.deployments;
  return (
    <div className="cc-card">
      <div className="cc-card-title">Deployments</div>
      {rows.length === 0 ? <div className="cc-empty">No deployments recorded yet. The next deploy will appear here.</div> :
        <div className="cc-rows">
          {rows.map((d) => {
            const isOpen = open === d.sha;
            return (
              <div key={d.sha} className="cc-deploy">
                <button className="cc-deploy-head" onClick={() => setOpen(isOpen ? null : d.sha)}>
                  <span className="cc-deploy-when">{fmtAbsTime(d.deployedAt)}</span>
                  <span className="cc-tag cc-tone-info">{d.short}</span>
                  <span className="cc-deploy-branch">{d.branch}</span>
                  <span className="cc-deploy-count">{d.commits.length} commit{d.commits.length === 1 ? "" : "s"}</span>
                  <span className="cc-deploy-rel">{fmtRelative(d.deployedAt)}</span>
                </button>
                {isOpen && (
                  <ul className="cc-deploy-commits">
                    {d.commits.length === 0 ? <li className="cc-empty">No commit detail</li> :
                      d.commits.map((c) => (
                        <li key={c.sha}><span className="cc-deploy-sha">{c.sha}</span> {c.subject}</li>
                      ))}
                  </ul>
                )}
              </div>
            );
          })}
        </div>}
    </div>
  );
}
